<div class=" row mt-3 " style="padding: 10px;">        
    <div class="col-md-12 row" >

        <div class="balance-container col-md-6">
            <p class="total-balance" >Total Available Balance: ₹{{totalBalance?.totalDepositAmount+totalBalance?.totalCreditAmount}}</p>

            <label *ngIf="currentStep ==='Deposit'" for="available-balance">Deposit Balance:</label>
            <label *ngIf="currentStep ==='Credit'" for="available-balance">Credit Balance:</label>

            <p class="total-balance"  *ngIf="currentStep ==='Deposit'">₹{{totalBalance?.totalDepositAmount}}</p>
            <p class="total-balance" *ngIf="currentStep ==='Credit'">₹{{totalBalance?.totalCreditAmount}}</p>

          </div>
          <div class=" col-md-6" style="text-align: right;">
            <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Billing Entity </mat-label>
              <mat-select matNativeControl name="billingEntity"  ngModel="default">
                <mat-option value="default">Default</mat-option>

              </mat-select>  
            </mat-form-field>  

          </div>

          
          <div class="stepper-container pb-3">
            <div
              *ngFor="let step of ['Deposit','Credit']"
              class="stepper-step"
              [class.active]="currentStep === step"
              (click)="changeStep(step)"
            >
              {{ step }}
            </div>
          </div>
          <mat-divider></mat-divider>

          <div class="pt-4 pb-4" *ngIf="currentStep ==='Deposit'">
            <form [formGroup]="DepositRegFg" class="col-md-12 row ">
                <mat-form-field class="col-md-2" appearance="outline">
                    
                    <mat-select matNativeControl name="bankName" formControlName="entryType" >
                      <mat-option value="credit">Add</mat-option>
                      <mat-option value="debit">Debit</mat-option>

                    </mat-select>  

                  </mat-form-field>
                  <mat-form-field class="col-md-3" appearance="outline">
                    <mat-label>Amount</mat-label>
                    <input matInput type="text" (keypress)="onlyNumberKey($event)"  name="amount" autocomplete="off" formControlName="amount">

                  </mat-form-field>  
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Notes</mat-label>
                    <textarea matInput type="text" rows="1"  name="note" autocomplete="off" formControlName="comment"></textarea>
                  </mat-form-field>  
                  <div class="col-md-3  " style="text-align: right;">
                    <button  class="btn btn-outline-success  shadow " style="padding-left: 80px;padding-right: 80px; padding-top: 14.5px;padding-bottom: 14.5px;" (click)="savePaymentDeposits()" [disabled]="DepositRegFg.invalid">Save</button>
                    </div>
            </form>

            <table >
              <thead>
                  <tr class="sticky-tabs ">
                      <th>Transaction Date</th>
                      <th>Amount</th>

                      <th>Cart Id</th>
                  </tr>
              </thead>
              <tbody>
                <tr *ngFor="let balance of BalanceHistoryList">
                  <td>{{formatDate(balance?.entryDate)||'-'}}</td>
                  <td>{{balance?.amount||'-'}}</td>

                  <td>{{balance?.ref||'-'}}</td>

                </tr>
                 
              </tbody>
          </table>            
          </div>
          <div class="pt-4 pb-4" *ngIf="currentStep ==='Credit'">
            <form [formGroup]="DepositRegFg" class="col-md-12 row ">
                <mat-form-field class="col-md-2" appearance="outline">
                    
                    <mat-select matNativeControl name="bankName" formControlName="entryType" >
                      <mat-option value="credit">Add</mat-option>
                      <mat-option value="debit">Debit</mat-option>

                    </mat-select>  

                  </mat-form-field>
                  <mat-form-field class="col-md-3" appearance="outline">
                    <mat-label>Amount</mat-label>
                    <input matInput type="text" (keypress)="onlyNumberKey($event)"  name="amount" autocomplete="off" formControlName="amount">

                  </mat-form-field>  
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Notes</mat-label>
                    <textarea matInput type="text" rows="1"  name="note" autocomplete="off" formControlName="comment"></textarea>
                  </mat-form-field>  
                  <div class="col-md-3  " style="text-align: right;">
                    <button  class="btn btn-outline-success  shadow " style="padding-left: 80px;padding-right: 80px; padding-top: 14.5px;padding-bottom: 14.5px;" (click)="savePaymentDeposits()" [disabled]="DepositRegFg.invalid">Save</button>
                    </div>
            </form>

            <table >
              <thead >
                  <tr class="sticky-tabs">
                      <th>Transaction Date</th>
                      <th>Amount</th>

                      <th>Cart Id</th>
                  </tr>
              </thead>
              <tbody>
                <tr *ngFor="let balance of BalanceHistoryList">
                  <td>{{formatDate(balance?.entryDate)||'-'}}</td>
                  <td>{{balance?.amount||'-'}}</td>
                  <td>{{balance?.ref||'-'}}</td>

                </tr>
                 
              </tbody>
          </table>        

            
            
          </div>